import { Component, EventEmitter, Output, ViewChild, ElementRef, OnDestroy, AfterViewInit, Input } from '@angular/core';
import { IonicSlides } from '@ionic/angular';
import Swiper from 'swiper';

import { Observable } from 'rxjs';

export enum TabList {
  DETAILS,
  RISKS,
  OPPORTUNITIES,
  IMPACT
}

@Component({
  selector: 'app-grow-intro-slider',
  templateUrl: './grow-intro-slider.component.html',
  styleUrls: ['./grow-intro-slider.component.scss'],
  standalone: false
})
export class GrowIntroSliderComponent implements AfterViewInit, OnDestroy {
  @ViewChild('swiperContainer', { static: false }) swiperContainer?: ElementRef<{ swiper: Swiper }>;
  @Input() isLoading;
  private slideChangeHandler?: (swiper: Swiper) => void;
  swiperModules = [IonicSlides];
  isLoading$: Observable<boolean>;
  currentSlideIndex = 0;
  slides = [
    {
      id: 1,
      imageSrc: '/assets/images/grow-intro-slide-1.jpg',
      imageAlt: 'Plant growing out of piggybank',
      heading: 'growIntro.slide1.heading',
      paragraph: 'growIntro.slide1.paragraph',
      cta: 'growIntro.slide1.cta'
    },
    {
      id: 2,
      imageSrc: '/assets/images/grow-intro-slide-2.jpg',
      imageAlt: 'Wooden block energy methods',
      heading: 'growIntro.slide2.heading',
      paragraph: 'growIntro.slide2.paragraph',
      cta: 'growIntro.slide2.cta'
    },
    {
      id: 3,
      imageSrc: '/assets/images/grow-intro-slide-3.jpg',
      imageAlt: 'pots with growing sprouts',
      heading: 'growIntro.slide3.heading',
      paragraph: 'growIntro.slide3.paragraph',
      cta: 'growIntro.slide3.cta'
    }
  ];

  @Output() finalSubmit: EventEmitter<void> = new EventEmitter<void>();

  ngAfterViewInit(): void {
    if (this.swiperContainer && this.swiperContainer.nativeElement?.swiper) {
      this.slideChangeHandler = (swiper: Swiper) => this.onSlideChange(swiper);
      this.swiperContainer.nativeElement.swiper.on('slideChange', this.slideChangeHandler);
    }
  }

  onSlideChange(swiper: Swiper): void {
    this.currentSlideIndex = swiper.activeIndex;
  }

  goToNextSlide(): void {
    if (this.currentSlideIndex === this.slides.length - 1) {
      this.finalSubmit.emit();
    } else {
      if (this.swiperContainer && this.swiperContainer.nativeElement?.swiper) {
        this.swiperContainer.nativeElement.swiper.slideNext();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.swiperContainer && this.swiperContainer.nativeElement?.swiper && this.slideChangeHandler) {
      this.swiperContainer.nativeElement.swiper.off('slideChange', this.slideChangeHandler);
    }
  }
}
